import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.for-each.js";
import { transformStr3, handleHttp, getformListItemsdata, getformListItemsdatas, insertStr, locationHandle, isWx, locationHandlev2, getformatstruct } from "@/utils/utils";
import Pagination from "@/view/map/customv2/pagination";
import Swiper from "swiper";
import "swiper/css/swiper.css";
import VueAudio from "vue-audio";
// import 'vue-audio-player/dist/vueaudioplayer.css'

import Viewer from "viewerjs";
import "viewerjs/dist/viewer.css";
export default {
  name: "fujianshifanPop",
  data() {
    return {
      fid: this.$route.query.fid,
      popLeftArr: [{
        name: "简介",
        id: 0
      }, {
        name: "教学资源",
        id: 4
      }, {
        name: "拓展资源",
        id: 5
      }, {
        name: "成果展示",
        id: 6
      }],
      popLeftIndex: 0,
      linkcontainerflag: false,
      iframeurl: "",
      infoList: [],
      videoitem: "",
      videoitemflag: false,
      daohangflag: true,
      viewer: null,
      audiodescflag: false,
      audiodesc: null,
      timer: null,
      structList: [],
      structLabel: {},
      structImgdefaultValues: {},
      showGood: false,
      teachCourse: [],
      teachCourseTotal: 0,
      teachType: [],
      journalbooks: [],
      journalbooksTotal: 0,
      journalType: [],
      achievement: [],
      achievementTotal: 0,
      achievementType: [],
      currentPage: 1,
      // 初始当前页，可根据实际情况设置
      currentItem: null,
      typeIndex: 0
    };
  },
  components: {
    VueAudio,
    Pagination
  },
  watch: {
    "$attrs.popshowflag"(val) {
      if (val) {
        console.log(`this.$attrs.detail.place_name`, this.$attrs.detail.place_name);
        this.getTeachCourse(this.$attrs.detail.place_name);
        this.getJournalBooks(this.$attrs.detail.place_name);
        this.getAchievement(this.$attrs.detail.place_name);
        this.getOtherStruct('jxkj', `teachType`);
        this.getOtherStruct('qksj', `journalType`);
        this.getOtherStruct('nav_3', `achievementType`);
      }
    },
    "$attrs.detail"(val) {
      if (val && Object.keys(val).length > 0) {
        if (this.structList.length === 0) {
          this.pointStruct();
        } else {
          this.setLeftTitle();
        }
      }
    },
    "$attrs.detail.banner"(val) {
      if (val) {
        this.$nextTick(() => {
          this.swiperEl = new Swiper(this.$refs.swipercontainer, {
            initialSlide: 0,
            slidesPerView: this.$attrs.isMobile ? 1 : 2.3,
            autoplay: true,
            speed: 500,
            spaceBetween: this.$attrs.isMobile ? 0 : 10,
            observeSlideChildren: true,
            observeParents: true,
            observer: true
          });
        });
        this.initViewer();
      }
    }
  },
  created() {
    isWx().then(type => {
      this.daohangflag = type === "mini-wx" ? false : true;
    });
  },
  mounted() {
    // this.getTeachCourse(this.$attrs.detail.place_name);
    // this.getJournalBooks(this.$attrs.detail.place_name)
  },
  methods: {
    getTeachCourse(location = "", page = 1, type = '') {
      let forms = {
        deptId: this.$route.query.fid,
        formId: "jxkj",
        page: page,
        limit: 8,
        t: "23df5dccfff24c238d31cdb5c879552e"
      };
      let searchStr = {
        model: 0,
        filters: [{
          model: 0,
          filters: [{
            alias: "yxzp_location",
            compt: "selectbox",
            express: "===",
            val: [location]
          }]
        }]
      };
      if (type !== '' && type !== '全部') {
        searchStr.filters.push({
          model: 0,
          filters: [{
            alias: "classify",
            compt: "selectbox",
            express: "===",
            val: type === '全部' ? [''] : [type]
          }]
        });
      }
      if (location) {
        forms.searchStr = encodeURI(JSON.stringify(searchStr));
      }
      this.$api.singleadvanceSearchv2(forms).then(res => {
        res.dataList.forEach((item, index) => {
          let itemformdata = item.formIdValueData;
          let itemformat = {};
          Object.keys(itemformdata).forEach(key => {
            itemformat[itemformdata[key].alias] = getformListItemsdatas(itemformdata[key]);
          });
          item.itemformdata = itemformat;
        });
        this.teachCourse = res.dataList;
        this.teachCourseTotal = res.totalPage;
        this.popLeftArr.forEach(item => {
          if (item.id === 4 && this.teachCourse.length > 0 && this.teachCourse[0].itemformdata.navigation_title !== '') {
            item.name = this.teachCourse[0].itemformdata.navigation_title;
          }
        });
        // this.teachCourse=[...res.dataList,...res.dataList,...res.dataList,...res.dataList]
      });
    },
    getJournalBooks(location = "", page = 1, type = '') {
      let forms = {
        deptId: this.$route.query.fid,
        formId: "qksj",
        page: page,
        limit: 8,
        t: "8870c3cff33e2fe7442731881665375b"
      };
      let searchStr = {
        model: 0,
        filters: [{
          model: 0,
          filters: [{
            alias: "ysal_place",
            compt: "selectbox",
            express: "===",
            val: [location]
          }]
        }]
      };
      if (type !== '') {
        searchStr.filters.push({
          model: 0,
          filters: [{
            alias: "classify",
            compt: "selectbox",
            express: "===",
            val: type === '全部' ? [''] : [type]
          }]
        });
      }
      if (location) {
        forms.searchStr = encodeURI(JSON.stringify(searchStr));
      }
      this.$api.singleadvanceSearchv2(forms).then(res => {
        res.dataList.forEach((item, index) => {
          let itemformdata = item.formIdValueData;
          let itemformat = {};
          Object.keys(itemformdata).forEach(key => {
            itemformat[itemformdata[key].alias] = getformListItemsdatas(itemformdata[key]);
          });
          item.itemformdata = itemformat;
        });
        this.journalbooks = res.dataList;
        this.journalbooksTotal = res.totalPage;
        this.popLeftArr.forEach(item => {
          if (item.id === 5 && this.journalbooks.length > 0 && this.journalbooks[0].itemformdata.navigation_title !== '') {
            item.name = this.journalbooks[0].itemformdata.navigation_title;
          }
        });
      });
    },
    getAchievement(location = "", page = 1, type = '') {
      let forms = {
        deptId: this.$route.query.fid,
        formId: "nav_3",
        page: page,
        limit: 8,
        t: "7dd0ad3c8eaed6e6b023e9c28ed921d8"
      };
      let searchStr = {
        model: 0,
        filters: [{
          model: 0,
          filters: [{
            alias: "ysal_place",
            compt: "selectbox",
            express: "===",
            val: [location]
          }]
        }]
      };
      if (type !== '') {
        searchStr.filters.push({
          model: 0,
          filters: [{
            alias: "classify",
            compt: "selectbox",
            express: "===",
            val: type === '全部' ? [''] : [type]
          }]
        });
      }
      if (location) {
        forms.searchStr = encodeURI(JSON.stringify(searchStr));
      }
      this.$api.singleadvanceSearchv2(forms).then(res => {
        res.dataList.forEach((item, index) => {
          let itemformdata = item.formIdValueData;
          let itemformat = {};
          Object.keys(itemformdata).forEach(key => {
            itemformat[itemformdata[key].alias] = getformListItemsdatas(itemformdata[key]);
          });
          item.itemformdata = itemformat;
        });
        this.achievement = res.dataList;
        this.achievementTotal = res.totalPage;
        this.popLeftArr.forEach(item => {
          if (item.id === 6 && this.achievement.length > 0 && this.achievement[0].itemformdata.navigation_title !== '') {
            item.name = this.achievement[0].itemformdata.navigation_title;
          }
        });
      });
    },
    toDetail(item) {
      this.showGood = true;
      this.currentItem = item;
      if (item.yxzp_content) {
        let res = this.replaceIframeSrc(item.yxzp_content);
        this.currentItem.yxzp_content = res;
      }
      if (item.ysal_content && item.ysal_content) {
        let res = this.replaceIframeSrc(item.ysal_content, {
          removeLast: true
        });
        res;
        this.currentItem.ysal_content = res;
      }
      if (item.ysal_introduction && item.ysal_introduction) {
        let res = this.replaceIframeSrc(item.ysal_introduction, {
          removeLast: true
        });
        res;
        this.currentItem.ysal_introduction = res;
      }
    },
    replaceIframeSrc(html, options = {}) {
      // 设置默认选项
      const defaultOptions = {
        targetSrc: "insertVideo.html",
        replaceSrc: "https://noteyd.chaoxing.com/attachment/insertVideo.html",
        parentClass: "editor-iframe",
        removeLast: false // 新增选项：是否移除最后一个 editor-iframe
      };
      const opts = {
        ...defaultOptions,
        ...options
      };

      // 边界条件处理
      if (!html || typeof html !== "string") {
        console.warn("传入的 HTML 文本无效");
        return html;
      }
      try {
        // 创建临时 DOM 元素用于解析 HTML
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = html;

        // 用于存储替换数量、样式修改数量和移除数量的计数器
        let replacedCount = 0;
        let styledCount = 0;
        let removedCount = 0;

        // 查找所有包含指定类名的父元素
        const parentElements = tempDiv.querySelectorAll(`.${opts.parentClass}`);

        // 遍历每个父元素，处理其内部的 iframe
        parentElements.forEach(parent => {
          const iframes = Array.from(parent.querySelectorAll("iframe"));
          iframes.forEach(iframe => {
            // 检查内容是否包含错误页面文本

            // 检查 src 属性是否包含目标链接
            if (iframe.src && iframe.src.endsWith(opts.targetSrc) || iframe.src && iframe.src.endsWith("insertCloud.html")) {
              // 特殊处理：如果目标是 insertCloud.html，则删除该 iframe
              if (iframe.src.endsWith("insertCloud.html")) {
                // iframe.parentNode.removeChild(iframe);
                iframe.src = "https://noteyd.chaoxing.com/attachment/insertCloud.html";
                replacedCount++;
              }
              if (iframe.src.endsWith(opts.targetSrc)) {
                // iframe.parentNode.removeChild(iframe);
                iframe.src = opts.replaceSrc;
                replacedCount++;
                // 为 iframe 追加样式
                const originalStyle = iframe.getAttribute("style") || "";
                const newStyle = "width:95%;height:410px;";
                // 合并样式并避免重复添加
                if (!originalStyle.includes(newStyle)) {
                  iframe.setAttribute("style", `${newStyle} ${originalStyle}`);
                  styledCount++; // 增加样式修改计数器
                }
              }
              // 替换为新的链接
              replacedCount++;
              // console.log(`已替换 iframe 链接: ${iframe.src}`);
            }
          });
        });

        // 返回处理后的 HTML 文本
        return tempDiv.innerHTML;
      } catch (error) {
        console.error("处理 iframe 时出错:", error);
        return html;
      }
    },
    homeback() {
      this.showGood = false;
    },
    handlePageChange(newPage) {
      this.currentPage = newPage;
      console.log(this.popLeftIndex);
      console.log("newPage", newPage);
      if (this.popLeftIndex == 4) {
        this.getTeachCourse(this.$attrs.detail.place_name, newPage);
      }
      if (this.popLeftIndex == 5) {
        this.getJournalBooks(this.$attrs.detail.place_name, newPage);
      }
      if (this.popLeftIndex == 6) {
        this.getAchievement(this.$attrs.detail.place_name, newPage);
      }
      // 这里可调用接口，根据 newPage 获取对应页的数据，比如：
      // this.fetchData(newPage);
    },
    // 统一换地址
    sethandleHttp(url) {
      return handleHttp(url);
    },
    // 关闭事件
    closePop() {
      this.showGood = false;
      this.$emit("closeHandle");
      this.popshowflag = false;
      this.popLeftIndex = 0;
      if (this.audiodescflag) {
        this.$refs.audiodesc.pause();
        this.audiodescflag = false;
      }
      this.closevideoItem();
    },
    closevideoItem() {
      this.videoitemflag = false;
      this.videoitem = "";
    },
    // 弹窗左边点击事件
    popLeftHandle(id) {
      this.popLeftIndex = id;
      this.showGood = false;
      this.typeIndex = 0;
    },
    // 返回事件
    goback() {
      this.linkcontainerflag = false;
      this.iframeurl = "";
    },
    goLocation(url) {
      locationHandlev2.call(this, this.$attrs.detail, url);
    },
    // 跳转
    goLink(url) {
      // 若选择打开新窗口处理
      if (this.$attrs.detail.linkTarget !== undefined && this.$attrs.detail.linkTarget === "是") {
        window.open(url);
      } else {
        this.linkcontainerflag = true;
        this.iframeurl = url;
      }
    },
    // 视频切换
    videoItemHandle(item) {
      this.videoitemflag = true;
      this.videoitem = this.popLeftIndex === 2 ? item : item.itemformdata;
    },
    initViewer() {
      this.$nextTick(() => {
        if (this.viewer) {
          this.viewer.destroy();
          this.viewer = null;
          return;
        }
        let that = this;
        this.viewer = new Viewer(document.querySelector(".swiper-wrapper"), {
          navbar: true,
          // 显示导航栏
          toolbar: true,
          // 显示工具栏
          title: false,
          viewed() {
            console.log(`this.$attrs.imgrotate`, that.$attrs.imgrotate);
            if (that.$attrs.imgrotate !== undefined && that.$attrs.imgrotate) that.viewer.rotateTo(90);
            document.querySelector(".viewer-container").classList.add(`fid${that.$route.query.fid}`);
          }
        });
      });
    },
    getAddress(val) {
      let data = val[0];
      let addressArr = ["country", "province", "city", "district", "street"];
      let str = "";
      addressArr.forEach(elem => {
        if (data[elem] && data[elem] !== undefined && data[elem] !== "") str += data[elem];
      });
      if (str === "" && data.address !== undefined) str = data.address;
      return str;
    },
    playaudiodesc() {
      this.audiodescflag = !this.audiodescflag;
      if (this.audiodescflag) {
        this.$refs.audiodesc.pause();
      } else {
        this.$refs.audiodesc.play().catch(error => {
          console.error("Play request was interrupted:", error);
        });
      }
    },
    /**
     * 获取地点管理表表单结构
     */
    pointStruct() {
      let params = {
        deptId: this.$route.query.fid,
        formId: 165054
      };
      this.$api.formStruct(params).then(res => {
        this.structList = JSON.parse(JSON.stringify(res));
        this.structList.forEach(elem => {
          if (elem.compt === "imagebox" && elem.field.values.length > 0) this.structImgdefaultValues[elem.alias] = elem.field.values[0].fileUrl;
          this.structLabel[elem.alias] = elem.label;
        });
        this.setLeftTitle();
        console.log(`this.structLabel`, this.structLabel);
        console.log(`this.structImgdefaultValues`, this.structImgdefaultValues);
      });
    },
    setLeftTitle() {
      let audioList = this.$attrs.detail.audio;
      if (audioList && audioList.length > 0) {
        let isHasaudio = this.popLeftArr.find(item => {
          return item.id === 3;
        });
        if (!isHasaudio) this.popLeftArr.push({
          name: this.structLabel.audio,
          id: 3
        });
      }
      let videoList = this.$attrs.detail.video;
      if (videoList && videoList.length > 0) {
        let isHasvideo = this.popLeftArr.find(item => {
          return item.id === 2;
        });
        if (!isHasvideo) this.popLeftArr.push({
          name: this.structLabel.video,
          id: 2
        });
      }
    },
    async getOtherStruct(formId, elem) {
      let params = {
        deptId: this.$route.query.fid,
        formId: formId
      };
      const resdata = await this.$api.formStruct(params);
      const structData = JSON.parse(JSON.stringify(resdata));
      const typeData = structData.find(item => {
        return item.alias === 'classify';
      });
      this[elem] = typeData.field.options;
      this[elem].unshift({
        title: '全部'
      });
    },
    typeClick(item, index) {
      this.typeIndex = index;
      if (this.popLeftIndex === 4) this.getTeachCourse(this.$attrs.detail.place_name, 1, item.title);
      if (this.popLeftIndex === 5) this.getJournalBooks(this.$attrs.detail.place_name, 1, item.title);
      if (this.popLeftIndex === 6) this.getAchievement(this.$attrs.detail.place_name, 1, item.title);
    }
  }
};